import {
	SET_CUSTOMER_FORMS,
	SET_CUSTOMER_FORM,
	SET_CUSTOMER_ID,
	SET_UPDATING_STATUS,
	CLEAR_CUSTOMER_FORMS,
	SET_RELOAD_CUSTOMER_FORMS,
	SET_IS_ON_ALL_STATUSES,
	TOAST_MESSAGES_PUSH
} from './mutation-types';

import { ApiService as api } from '@/services/axiosHelper';
import _ from 'lodash';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: 'customer-forms',
	namespaced: true,
	state: {
		customerForms: {},
		form: {},
		customerId: '',
		reloadCustomerForms: false,
		isOnAllStatuses: false,
		updatingStatus: false
	},
	mutations: {
		[SET_CUSTOMER_FORMS](state, customerForms) {
			state.customerForms = customerForms;
		},
		[CLEAR_CUSTOMER_FORMS](state) {
			state.customerForms = {
				countPerPage: 100,
				items: [],
				page: 1,
				totalCount: 0,
				totalPageCount: 0
			};
		},
		[SET_CUSTOMER_FORM](state, form) {
			state.form = form;
		},
		[SET_CUSTOMER_ID](state, customerId) {
			state.customerId = customerId;
		},
		[SET_RELOAD_CUSTOMER_FORMS](state, reload) {
			state.reloadCustomerForms = reload;
		},
		[SET_IS_ON_ALL_STATUSES](state, value) {
			state.isOnAllStatuses = value;
		},
		[SET_UPDATING_STATUS](state, value) {
			state.updatingStatus = value;
		}
	},
	actions: {
		async getFormsByCustomer({ commit, dispatch }, parameters) {
			let params = _.cloneDeep(parameters);

			const valuesToRemove = [undefined, '', 'all'];
			params = _.omitBy(params, value => valuesToRemove.includes(value));

			commit(CLEAR_CUSTOMER_FORMS);

			return new Promise((resolve, reject) => {
				api.get(`/customer/${parameters.id}/forms`, {
					params
				})
					.then(res => {
						commit(SET_CUSTOMER_FORMS, res);
						resolve();
					})
					.catch(err => {
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		},
		async getForm({ commit }, id) {
			const result = await api.get(`/forms/${id}`);
			commit(SET_CUSTOMER_FORM, result);
			return result;
		},
		setCustomerId({ commit }, value) {
			commit(SET_CUSTOMER_ID, value);
		},
		reloadCustomerForms({ commit }, value) {
			commit(SET_RELOAD_CUSTOMER_FORMS, value);
		},
		async updateFormStatus({ dispatch }, parameters) {
			return new Promise((resolve, reject) => {
				api.post(
					`/customer/${parameters.id}/${parameters.action}/${parameters.formId}`
				)
					.then(() => {
						resolve();
					})
					.catch(err => {
						console.log(err);
						dispatch(
							TOAST_MESSAGES_PUSH,
							{
								statusCode: 400,
								message: err
							},
							{
								root: true
							}
						);
						reject();
					});
			});
		}
	},
	getters: {
		customerForm: state => state.form,
		customerId: state => state.customerId,
		reloadCustomerForms: state => state.reloadCustomerForms,
		isOnAllStatuses: state => state.isOnAllStatuses
	}
};
